import { tabScopedStorage } from './preauth';

export type ReclassificationSelection = { state: string; assessment: string };

export type ReclassificationSelectionStore = Pick<Storage, 'getItem' | 'setItem'>;

const STORAGE_KEY = 'bamboo.reclassificationSelection';

function browserStorage(): ReclassificationSelectionStore | null {
  try {
    const s = tabScopedStorage();
    if (typeof s?.getItem === 'function' && typeof s?.setItem === 'function') return s;
    return null;
  } catch {
    return null;
  }
}

function isSane(value: unknown): value is ReclassificationSelection {
  if (typeof value !== 'object' || value == null) return false;
  const s = value as Record<string, unknown>;
  return typeof s.state === 'string' && typeof s.assessment === 'string';
}

export function loadReclassificationSelection(
  store: ReclassificationSelectionStore | null = browserStorage()
): ReclassificationSelection | null {
  try {
    const raw = store?.getItem(STORAGE_KEY);
    if (raw == null) return null;
    const parsed: unknown = JSON.parse(raw);
    if (!isSane(parsed)) return null;
    return { state: parsed.state, assessment: parsed.assessment };
  } catch {
    return null;
  }
}

export function saveReclassificationSelection(
  selection: ReclassificationSelection,
  store: ReclassificationSelectionStore | null = browserStorage()
): boolean {
  if (store == null) return false;
  try {
    store.setItem(STORAGE_KEY, JSON.stringify(selection));
    return true;
  } catch {
    return false;
  }
}
